var $ = jQuery;
$(document).ready(function(){
  var num = $('.santa-frm-inr').length;
  if (num - 1 == 0)
    $('.remove-package-btn').attr('disabled', 'disabled');
  
  $(document).on('click','.add-more-btn',function(e){
    e.preventDefault();
    var pro_val = true;
    $('.santa-frm-inr').each(function(i,v){
      let cnt_l = 0;
      if($(this).closest('.santafrm-fields-wrap').css('display') != 'none'){
        $(this).find('input').each(function(){
          var cur_val = $(this).val();
          if(cur_val == '' || $(this).attr('required') == 'required' && cur_val == '' || $(this).attr('required') == undefined){
            cnt_l = cnt_l + 1;
          }
        });
      }
      
      if(cnt_l > 1) 
        pro_val = false;
    });
    if(pro_val == false){
      $('.santa_frm_error').remove();
      $('.santa-frm-wrap').append('<p class="santa_frm_error">Error: Please Fill Required Fields</p>').find('.santa_frm_error').fadeIn().delay(2000).fadeOut();
      return false;
    }
    let num = $('.santa-frm-inr').length;
    let newNum = num + 1;

    if (num - 1 == 0){
      $('.remove-package-btn').attr('disabled', 'disabled');
    }
    
    if(num <= 4){
      let newElem = $('#package-1').clone().attr('id', 'package-' + newNum).attr('data-box', 'package-' + newNum);
      console.log(newElem,'gfggg');
      newElem.find('h2 span').text(newNum);
      newElem.attr('data-count',newNum);
      
      newElem.find('.santa-field-fname label').attr('for', 'first-name_' + newNum).val('');
      newElem.find('.santa-field-fname input').attr('id', 'first-name_' + newNum).attr('name', 'properties[First Name '  + newNum + ']').attr('data-val', 'First Name '  + newNum).val('');
  
      newElem.find('.santa-field-lname label').attr('for', 'last-name_' + newNum).val('');
      newElem.find('.santa-field-lname input').attr('id', 'last-name_' + newNum).attr('name', 'properties[Last Name '  + newNum + ']').attr('data-val', 'Last Name '  + newNum).val('');
  
      newElem.find('.santa-field-friendsname label').attr('for', 'friends-name_' + newNum).val('');
      newElem.find('.santa-field-friendsname input').attr('id', 'friends-name_' + newNum).attr('name', 'properties[Friends Name '  + newNum + ']').attr('data-val', 'Friends Name '  + newNum).val('');
  
      newElem.find('.santa-field-address label').attr('for', 'street-address_' + newNum).val('');
      newElem.find('.santa-field-address input').attr('id', 'street-address_' + newNum).attr('name', 'properties[Street Address '  + newNum + ']').attr('data-val', 'Street Address '  + newNum).val('');
  
      newElem.find('.santa-field-unit label').attr('for', 'unit-apt_' + newNum).val('');
      newElem.find('.santa-field-unit input').attr('id', 'unit-apt_' + newNum).attr('name', 'properties[Unit/APT '  + newNum + ']').attr('data-val', 'Unit/APT '  + newNum).val('');
      
      newElem.find('.santa-field-city label').attr('for', 'city_' + newNum).val('');
      newElem.find('.santa-field-city input').attr('id', 'city_' + newNum).attr('name', 'properties[City '  + newNum + ']').attr('data-val', 'City '  + newNum).val('');
  
      newElem.find('.santa-field-state label').attr('for', 'state_' + newNum).val('');
      newElem.find('.santa-field-state select').attr('id', 'state_' + newNum).attr('name', 'properties[State '  + newNum + ']').attr('data-val', 'State '  + newNum).val('');

      newElem.find('.santa-field-date label').attr('for', 'date_' + newNum).val('');
      newElem.find('.santa-field-date select').attr('id', 'date_' + newNum).attr('name', 'properties[Date '  + newNum + ']').attr('data-val', 'Date '  + newNum).val('');

      newElem.find('.santa-field-zipcode label').attr('for', 'zip-code_' + newNum).val('');
      newElem.find('.santa-field-zipcode input').attr('id', 'zip-code_' + newNum).attr('name', 'properties[Zip Code '  + newNum + ']').attr('data-val', 'Zip Code '  + newNum).val('');
      
      $('#package-' + num).after(newElem);
      $('#package-' + newNum).find('.copy-address-btn').css('display','block');
      $('.remove-package-btn').attr('disabled', false);
    }else{
      $(this).attr('disabled','disabled');
    }
  });
  $(document).on('click','.gift-add-btn',function(e){
        e.preventDefault();
    var $this = $(this);
    var pro_val = true;

    var total_form = $('.santa-frm-inr').length;
    for ( var i = 1; i <= total_form; i++) {
      var form_data_array = [];
     form_data_array[0] = $('#package-' +i+ ' input[id="first-name_'+i+'"]').val();
     form_data_array[1] = $('#package-' +i+ ' input[id="last-name_'+i+'"]').val();
     form_data_array[2] = $('#package-' +i+ ' input[id="friends-name_'+i+'"]').val();
     form_data_array[3] = $('#package-' +i+ ' input[id="city_'+i+'"]').val();
     form_data_array[4] = $('#package-' +i+ '  select[id="state_'+i+'"] option:selected').val();

    localStorage.setItem("product_form_"+i, JSON.stringify(form_data_array));
    //var getStore = localStorage.getItem("product_form_"+i);
  //   var storeArray = getStore.replace("[", "").replace("]", "").split(',');
  // console.log(storeArray[2]);
   
}
localStorage.setItem("product_total_form", total_form);
var get_from_total = localStorage.getItem("product_total_form");
var personalize = $('.cart__items').attr('data-personalize');
    
    $('.santa-frm-inr').each(function(i,v){
      let cnt_l = 0;
      if($(this).closest('.santafrm-fields-wrap').css('display') != 'none'){
        $(this).find('input').each(function(){
          var cur_val = $(this).val();
          if(cur_val == '' || $(this).attr('required') == 'required' && cur_val == '' || $(this).attr('required') == undefined ){
            cnt_l = cnt_l + 1;
          }
        });
         console.log('ddddd',pro_val)
        if($(this).find('select').val() == ''){
           cnt_l = cnt_l + 1;
        }
      }
      if(cnt_l > 1) 
        pro_val = false;
    });
    if($('#shipping-date option:selected').val() == 'no-date' ){
       pro_val = false;
    }
   
    if(pro_val == false){
      $('.santa_frm_error').remove();
      $('.santa-frm-wrap').append('<p class="santa_frm_error">Error: Please Fill Required Fields</p>').find('.santa_frm_error').fadeIn().delay(2000).fadeOut();
      return false;
    } 
    
    let num = $('.santa-frm-inr').length;
    let newNum = num + 1;
    if (num - 1 == 0){
      $('.remove-package-btn').attr('disabled', 'disabled');
    }
    
    if(num <= 4){
      $('.remove-package-btn').attr('disabled', false);
    }else{
      $(this).attr('disabled','disabled');
    }
    let id = $this.closest('.santa-form').find('.product-variant-id').val();
    let qty = $('.santa-frm-inr').length;
    var pro_val = true;

    $('.santa-frm-inr').each(function(i,v){
      var loop_index = i+1;
      var arr=[];
      var items = {};
      var prop = {};
      $(this).find('.santa-input').each(function(i,v){
        var cur_val = $(this).val();
        var cur_prop = $(this).attr('data-val');
         if(cur_val == ''){
          pro_val = false;
         }
        if(cur_val != '' && cur_prop != ''){
            prop[cur_prop] = cur_val;
        }
      });
      prop["_santagift"] = $(this).attr('data-box');
      prop['Date'] = $('#shipping-date').val();
      items.id = id;
      items.properties = prop;
      items.quantity = 1;  
      arr.push(items); 
      var cur_box = $(this).attr('data-box');
      let formData = {
     'items': arr
    };
      if($('.cart__item.'+cur_box).length > 0 ){
        var item_key = $('.cart__item.'+cur_box).attr('data-key');
        var item_qty = parseInt($('.cart__item.'+cur_box).find('.js-qty__num').val());
         jQuery.ajax({
          url: '/cart/change.js',
          type: 'post',
          dataType: 'json',
          async: false,
          data: {
            id: item_key,
            quantity: item_qty,
            properties: prop
          },
          error: function(jqXHR, textStatus, errorThrown) {
           console.log('error when removing product from the cart');
          },
           success: function(data) {
             if(loop_index == num){
                window.location.href = "/cart";
             }
           }
        });
      }else{
        console.log('data-line',i);
        $.ajax({
          type: 'POST', 
          url: '/cart/add.js',
          dataType: 'json', 
          async: false,
          data: formData,
          error: function(jqXHR, textStatus, errorThrown) {
            console.log('ddddddddddderror when removing product from the cart');
          },
           success: function(data) {
             if(loop_index == num){
                window.location.href = "/cart";
             }
           }
        });
      }
    });
    
    
    
    if( $('#shipping-date option:selected').val() != 'no-date' &&  $('select[name=state] option:selected').val() != 'Select State' ) {
    }else {
      $('.santa_frm_error').remove();
      $('.santa-frm-wrap').append('<p class="santa_frm_error">Error: Please Fill Required Fields</p>').find('.santa_frm_error').fadeIn().delay(2000).fadeOut();
    }
  });
  $(document).on('click','.remove-package-btn',function(e){
    e.preventDefault();
    var num = $(this).parents('.santa-frm-inr').attr('data-count');
    var count = $('.santa-frm-inr').length;
    $('#package-' + num).remove();
    $('.remove-package-btn').attr('disabled', false);
    if (count - 1 == 1)
      $('.remove-package-btn').attr('disabled', 'disabled');
  });
  $(document).on('click','.copy-address-btn',function(e){
    e.preventDefault();
    let prev = $(this).parents('.santa-frm-inr').attr('data-count') - 1;
    $(this).parents('.santa-frm-inr').find('.santa-field-address input').val($('#package-' + prev).find('.santa-field-address input').val());
    $(this).parents('.santa-frm-inr').find('.santa-field-unit input').val($('#package-' + prev).find('.santa-field-unit input').val());
    $(this).parents('.santa-frm-inr').find('.santa-field-city input').val($('#package-' + prev).find('.santa-field-city input').val());
    $(this).parents('.santa-frm-inr').find('.santa-field-state select').val($('#package-' + prev).find('.santa-field-state select').val());
    $(this).parents('.santa-frm-inr').find('.santa-field-zipcode input').val($('#package-' + prev).find('.santa-field-zipcode input').val());
  });
});

var url = window.location.href;
var get_from_total = localStorage.getItem("product_total_form");
console.log('demo',get_from_total);
if(window.location.pathname == '/products/personalized-letters-from-santa' && get_from_total != null){

  setTimeout(function(){
    for (var j = 1; j <= get_from_total; j++) {
      var get_form_json = localStorage.getItem("product_form_" + j);
      var get_form_array = JSON.parse(get_form_json);
        
      $('#package-' + j + ' input[id="first-name_' + j + '"]').val(get_form_array[0]);
      $('#package-' + j + ' input[id="last-name_' + j + '"]').val(get_form_array[1]);
      $('#package-' + j + ' input[id="friends-name_' + j + '"]').val(get_form_array[2]);
      $('#package-' + j + ' input[id="city_' + j + '"]').val(get_form_array[3]);
      $('#package-' + j + ' select[id="state_' + j + '"] option[value="'+get_form_array[4]+'"]').attr('selected', true).change();
      $('#package-' + j + ' select[id="state_' + j + '"]').val(get_form_array[4]).change();
      if (get_from_total != j) {
        jQuery('.santa-add-more a').click();
      }
    }
    },1000);
// });
}


  $(document).ready(function () {
    // Detect browser back button press
       $(window).on('pageshow', function (event) { 
      // Check if the page is the product page and if it's a persisted back-forward navigation
      if (event.originalEvent.persisted && window.location.pathname === '/products/personalized-letters-from-santa') {
        // Perform actions and force a hard refresh
        location.reload(true);
        console.log('Browser back button pressed on product page');
      }
    });

    if(!!window.performance && window.performance.navigation.type == 2)
{
   if (window.location.pathname === '/products/personalized-letters-from-santa') {
        // Perform actions when the back button is pressed
        location.reload(); // Refresh the page or perform other actions
        console.log('Browser back button pressed on product page');
      }
}
    
    $(window).on('popstate', function(event) {
      // Check if the page is the product page
      if (window.location.pathname === '/products/personalized-letters-from-santa') {
        // Perform actions when the back button is pressed
        location.reload(); // Refresh the page or perform other actions
        console.log('Browser back button pressed on product page');
      }
    });
  });


    $('body').on('click','.cart__edit',function(e){
      e.preventDefault();
      
      var product_index = parseInt($(this).parents('.cart__item').attr('data-index'));
      var get_from_total = localStorage.getItem("product_total_form");
      
        setTimeout(function(){
          var get_form_json = localStorage.getItem("product_form_" + product_index);
          var get_form_array = JSON.parse(get_form_json);
          console.log(get_form_array);  
          $('#package-' + product_index + ' input[id="first-name_' + product_index + '"]').val(get_form_array[0]);
          $('#package-' + product_index + ' input[id="last-name_' + product_index + '"]').val(get_form_array[1]);
          $('#package-' + product_index + ' input[id="friends-name_' + product_index + '"]').val(get_form_array[2]);
          $('#package-' + product_index + ' input[id="city_' + product_index + '"]').val(get_form_array[3]);
          $('#package-' + product_index + ' select[id="state_' + product_index + '"] option[value="'+get_form_array[4]+'"]').attr('selected', true).change();
          $('#package-' + product_index + ' select[id="state_' + product_index + '"]').val(get_form_array[4]).change();
        },500);

         $(this).parents('.cart__item ').find('.santa-frm-wrap').addClass('poup-close');
    });

    $('body').on('click','.package-update',function(e){
      e.preventDefault();

    let id = $(this).closest('.santa-form').find('.cart__item ').attr('data-key');
    let qty = $('.santa-frm-inr').length;
    var pro_val = true;
    var inde_pro = parseInt($(this).parents('.cart__item').attr('data-index')); 
      var arr=[];
      var items = {};
      var prop = {};
      $(this).closest('.cart__item').find('.santa-input').each(function(i,v){
        var cur_val = $(this).val();
        var cur_prop = $(this).attr('data-val');
         if(cur_val == ''){
          pro_val = false;
         }
        if(cur_val != '' && cur_prop != ''){
            prop[cur_prop] = cur_val;
        }
      });
    
      prop["_santagift"] = $(this).closest('.santa-frm-inr').attr('data-box');
      prop['Date'] = $(this).closest('.cart__item').find('#shipping-date').val();
      console.log('prop',prop) ;
      
      var cur_box = $(this).closest('.santa-frm-inr').attr('data-box');
        var item_key = $(this).closest('.cart__item').attr('data-key');
        console.log(item_key)
        var item_qty = parseInt($(this).closest('.cart__item').find('.js-qty__num').val());
         jQuery.ajax({
          url: '/cart/change.js',
          type: 'post',
          dataType: 'json',
          async: false,
          data: {
            id: item_key,
            quantity: item_qty,
            properties: prop
          },
          error: function(jqXHR, textStatus, errorThrown) {
           console.log('error when removing product from the cart');
          },
           success: function(data) {
            console.log('sucess');
               var form_data_array = [];
               form_data_array[0] = $('#package-' +inde_pro+ ' input[id="first-name_'+inde_pro+'"]').val();
               form_data_array[1] = $('#package-' +inde_pro+ ' input[id="last-name_'+inde_pro+'"]').val();
               form_data_array[2] = $('#package-' +inde_pro+ ' input[id="friends-name_'+inde_pro+'"]').val();
               form_data_array[3] = $('#package-' +inde_pro+ ' input[id="city_'+inde_pro+'"]').val();
               form_data_array[4] = $('#package-' +inde_pro+ '  select[id="state_'+inde_pro+'"] option:selected').val();
          
             localStorage.setItem("product_form_"+inde_pro, JSON.stringify(form_data_array));
             console.log(form_data_array);
             location.reload();
           }
       });
   
 });

$('body').on('click','.close-icon',function(e){
  e.preventDefault();
  $(this).closest('.santa-frm-wrap').removeClass('poup-close');
});




 